import { gql } from 'apollo-angular';
import { userItemFragment } from './shared-user.fragments';

export const UpdateBasicUserFieldsMutation = gql`
  mutation updateBasicUserFields($input: UpdateBasicUserFieldsInput!) {
    updateBasicUserFields(input: $input) {
      user {
        ...UserItem
        streakEnabled
        streakSendGeneralReminders
        streakSendEndingReminders
        badgesEnabled
        badgesSendNotifications
        fullSizeAvatarUrl
        avatarUrl
        thumbUrl
      }

      errors {
        message
        path
      }
    }
  }
  ${userItemFragment}
`;

export const ResetPasswordMutation = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      email
      source

      clientMutationId
      errors {
        message
        path
      }
    }
  }
`;
